import { render } from "./WarehouseItem.vue?vue&type=template&id=517b89c2&scoped=true"
import script from "./WarehouseItem.vue?vue&type=script&lang=js"
export * from "./WarehouseItem.vue?vue&type=script&lang=js"

import "./WarehouseItem.vue?vue&type=style&index=0&id=517b89c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517b89c2"]])

export default __exports__